import * as amplitude from '@amplitude/analytics-browser';

import { isProdEnvironment } from '../utils';

export const initializeAmplitude = () => {
	if (isProdEnvironment()) {
		amplitude.init('59c0b3a196f7aebdcf49e42352de4e0c');
	}
};
